<div class="progress-loader">
  <div class="loaders-grid">
    <div class="loader-card">
      <div class="loader-display">
        <div class="loader3">
          <div class="loader3-bar"></div>
          <div class="loader3-bar"></div>
          <div class="loader3-bar"></div>
          <div class="loader3-bar"></div>
          <div class="loader3-bar"></div>
        </div>
      </div>
    </div>
  </div>
</div>